<template>
	<module-tab name="配送方式" enable-flex @mounted="update" @activated="$refs.table.update()">
		<m-operate>
			<c-button color="main" @click="$refs.logisticsCompanySelector.open()">添加配送方式</c-button>
    </m-operate>

    <c-table ref="table" height="grow">

      <c-table-column
          label="配送方式代码"
          name="code"
          width="110"
      >
      </c-table-column>

      <c-table-column
          label="配送方式名称"
          name="name"
          width="140"
      >
      </c-table-column>

      <c-table-column
          label="是否启用"
          width="120"
      >
        <template #default="{data}">
          <c-switch v-model="data.state" :state-value="[2, 1]" :state-text="['启用', '禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
        </template>
      </c-table-column>

      <c-table-column
          label="创建日期"
          name="create_date"
          width="140"
      >
      </c-table-column>

      <c-table-column
          type="sort"
          label="排序"
          name="sort_id"
          @handle="sortHandle"
      >
      </c-table-column>

      <c-table-column
          type="button"
          fixed="right"
          label="操作"
          width="160"
      >
        <template v-slot="{data}">
          <c-table-button  @click="del(data.id,data.name)">删除</c-table-button>
        </template>
      </c-table-column>
    </c-table>

    <logistics-company-selector ref="logisticsCompanySelector" multiple @resolve="seleteLogisticsCompany"></logistics-company-selector>
  </module-tab>
</template>

<script>
  import logisticsCompanySelector from '@/components/service/logistics_company_selector.vue'; //配送方式
	export default {
    components: {logisticsCompanySelector},
		data() {
			return {
        isCollect: [{
          name: '不支持',
          value: 0
        },{
          name: '支持',
          value: 1
        }],
        stateType: [{
          name: '禁用',
          value: 1
        },{
          name: '启用',
          value: 2
        }],
        editState: false,
        company_ids:[]
			}
		},

    methods: {
      update() {
        this.$refs.table.load({
          url: '/logistics_company/list'
        });
      },

      searchHandle(data) {
        this.$refs.table.load({
          url: '/logistics_company/list',
          data
        });
      },

      sortHandle(row, type, next) {
        //row.prev() 上一行数据
        //row.next() 下一行数据
        let submitData ={};
        if(type=='top' || type=='bottom'){
          submitData.type = type;
          submitData.id = row.data.id;
        }
        if(type=='up'){
          submitData.id1 = row.data.id;
          submitData.id2 = row.prev().data.id;
        }
        if(type=='down'){
          submitData.id1 = row.data.id;
          submitData.id2 = row.next().data.id;
        }
        this.request({
          url: '/logistics_company/sort',
          data: submitData,
          loading: true,
          success: data => {
            next();
          }
        });
      },

      seleteLogisticsCompany(list) {
        this.company_ids = [];
        if (list){
            //添加初始值
            list.forEach(ll => {
              this.company_ids.push(ll.id);
            });
            this.request({
              url: '/logistics_company/batch/add',
              data: {
                company_ids: this.company_ids
              },
              success: () => {
                this.$message({
                  message: '添加配送方式成功',
                  type: 'success'
                });
                this.$refs.table.update();
              }
            });
        }// end if
      },

      del(id,name) {
        this.$confirm({
          message: '确定要删除配送方式【'+name+'】吗？',  // 提示内容,
          buttonName: '确定',  // 确定按钮文字
          cancelButton: true,  // 是否显示取消按钮
          resolve: () => {
            this.request({
              url: '/logistics_company/remove',
              data: {id:id},
              loading: true,
              success: data => {
                this.$message({
                  message: '刪除成功',
                  type: 'success'
                });
                this.$refs.table.update();
              }
            });
          },  // 确定按钮回调
          cancel: () => {},  // 取消按钮回调
        });
      },
      /**
       * 启禁用
       * @param state
       * @param next
       * @param data
       */
      stateHandle(state, next, data) {
        this.request({
          url: '/logistics_company/state',
          data: {
            id: data.id,
            state: state ? 1 : 2
          },
          success: () => {
            next();
          }
        })
      }
    }
	}
</script>

<style>
</style>